var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.518,
    height: 15.518,
    viewBox: "0 0 15.518 15.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-coins",
    "data-name": "Icon awesome-coins",
    d: "M0,12.284v1.294c0,1.07,2.607,1.94,5.819,1.94s5.819-.87,5.819-1.94V12.284c-1.252.882-3.54,1.294-5.819,1.294S1.252,13.166,0,12.284Zm9.7-8.4c3.213,0,5.819-.87,5.819-1.94S12.911,0,9.7,0,3.879.87,3.879,1.94,6.486,3.879,9.7,3.879ZM0,9.1v1.564c0,1.07,2.607,1.94,5.819,1.94s5.819-.87,5.819-1.94V9.1a9.76,9.76,0,0,1-5.819,1.564A9.76,9.76,0,0,1,0,9.1Zm12.608.333c1.737-.336,2.91-.961,2.91-1.679V6.465a7.443,7.443,0,0,1-2.91,1.046ZM5.819,4.849C2.607,4.849,0,5.934,0,7.274S2.607,9.7,5.819,9.7s5.819-1.085,5.819-2.425S9.032,4.849,5.819,4.849Zm6.647,1.706c1.818-.327,3.052-.97,3.052-1.706V3.555a9.867,9.867,0,0,1-4.871,1.267A3.394,3.394,0,0,1,12.466,6.556Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/coin-icon.b4f94f58119f007d2d829d7d66872dfa.svg";
export { ForwardRef as ReactComponent };